var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{attrs:{"cols":"1","cols-md":"2"}},[(_vm.visibleDashboardElement(_vm.$enums.UserInterfaceElement.UserTask.Value))?_c('div',{staticClass:"eh-panel"},[_c('daily-task')],1):_vm._e(),(
      _vm.hasSelectedProject() &&
      _vm.visibleDashboardElement(_vm.$enums.UserInterfaceElement.UserTask.Value)
    )?_c('div',{staticClass:"eh-panel"},[_c('project-progress',{attrs:{"project":_vm.project}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }